import uniq from 'lodash.uniq';

import { SHAKE_LOOP_KEY, BOUNCE_LOOP_KEY } from 'js/config/consts';
import { ExistingScribeModel, VSImageShapeOrTextElementModel } from 'js/types';

import { defaultShakeLoops, defaultBounceEmphasisLoops } from '../resources/scribedefaults';

const getAnimationLoops = ({
  elements,
  scribe
}: {
  elements: VSImageShapeOrTextElementModel[];
  scribe: ExistingScribeModel;
}) => {
  const { settings } = scribe;
  const defaultLoops = settings.emphasisAnimationLoops;

  let loopsList = [];
  for (const el of elements) {
    if (el?.emphasisTween?.id === SHAKE_LOOP_KEY) {
      loopsList.push(
        el.emphasisAnimationLoops && el.emphasisAnimationLoops !== 0 ? el.emphasisAnimationLoops : defaultShakeLoops
      );
    } else if (el?.emphasisTween?.id === BOUNCE_LOOP_KEY) {
      loopsList.push(
        el.emphasisAnimationLoops && el.emphasisAnimationLoops !== 0
          ? el.emphasisAnimationLoops
          : defaultBounceEmphasisLoops
      );
    } else {
      loopsList.push(
        el.emphasisAnimationLoops && el.emphasisAnimationLoops !== 0 ? el.emphasisAnimationLoops : defaultLoops
      );
    }
  }

  const uniqueLoops = uniq(loopsList);

  return uniqueLoops.length === 1 ? uniqueLoops[0] : '-';
};

export default getAnimationLoops;
